import { NavLink, Outlet } from "react-router-dom";
import { useBuzz } from "./lib/BuzzProvider";
import { shortPubkey } from "./lib/identity";

function statusClass(state: string): string {
  switch (state) {
    case "ready":
      return "ok";
    case "connecting":
    case "authing":
      return "warn";
    default:
      return "danger";
  }
}

export function AppShell() {
  const { client, identity } = useBuzz();

  return (
    <div className="app-shell chat-shell">
      <aside className="sidebar">
        <div className="brand">
          <strong>Buzz</strong>
          <span>CDMSuite · multi-agent rooms</span>
        </div>
        <nav className="nav">
          <NavLink to="/" end>
            Workspace
          </NavLink>
          <NavLink to="/trading">Trading</NavLink>
          <NavLink to="/ai">Workers AI</NavLink>
          <NavLink to="/settings">Identity</NavLink>
          <NavLink to="/debug">Relay debug</NavLink>
        </nav>
        <div className="stack sidebar-foot">
          <span className={`badge ${statusClass(client.state)}`}>Relay {client.state}</span>
          <span className="muted mono tiny">{shortPubkey(identity.pubkey)}</span>
          <span className="muted tiny" style={{ wordBreak: "break-all" }}>
            {client.relayUrl}
          </span>
        </div>
      </aside>
      <main className="main chat-main">
        <Outlet />
      </main>
    </div>
  );
}
